import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana67Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
  <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1255 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1255" height="921" fill="url(#pattern0_1465_19732)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("32"))}
      d="M679.28 191.184L662.824 227.893L618.52 207.639L624.849 192.449L662.824 175.993C679.027 172.955 680.546 184.854 679.28 191.184Z" 
      fill={getFillByLot(32, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("31"))}
      d="M647.636 267.135L662.826 227.894L618.521 207.641L602.065 248.148L647.636 267.135Z" 
      fill={getFillByLot(31, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M560.292 220.3L624.85 192.451L599.534 253.212L555.229 232.958L560.292 220.3Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("30"))}
      d="M632.446 305.106L647.636 267.13L602.066 248.143L586.875 284.852L632.446 305.106Z" 
      fill={getFillByLot(30, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("2"))}
      d="M538.77 269.666L555.225 232.957L599.53 253.211L584.34 291.186L538.77 269.666Z" 
      fill={getFillByLot(2, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("29"))}
      d="M615.989 344.348L632.445 305.107L586.874 284.854L571.684 324.095L615.989 344.348Z" 
      fill={getFillByLot(29, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("3"))}
      d="M524.848 305.112L538.772 269.668L584.342 291.187L570.418 325.365L524.848 305.112Z" 
      fill={getFillByLot(3, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("4"))}
      d="M509.658 341.817L524.848 305.107L570.419 325.361L555.229 362.07L509.658 341.817Z" 
      fill={getFillByLot(4, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("28"))}
      d="M599.534 382.33L555.229 362.077L571.685 324.102L615.989 344.355L599.534 382.33Z" 
      fill={getFillByLot(28, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("27"))}
      d="M583.074 421.567L599.53 382.326L555.225 362.072L538.77 401.313L583.074 421.567Z" 
      fill={getFillByLot(27, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("26"))}
      d="M567.885 459.537L583.075 421.562L538.771 401.309L522.315 439.284L567.885 459.537Z" 
      fill={getFillByLot(26, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("5"))}
      d="M494.468 377.262L509.658 341.818L555.229 362.072L540.039 398.781L494.468 377.262Z" 
      fill={getFillByLot(5, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("6"))}
      d="M479.277 413.969L494.467 377.26L540.038 398.779L523.582 435.489L479.277 413.969Z" 
      fill={getFillByLot(6, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("25"))}
      d="M552.699 497.52L567.889 459.545L522.319 439.291L507.129 476L552.699 497.52Z" 
      fill={getFillByLot(25, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("24"))}
      d="M536.24 536.762L552.696 497.521L507.125 476.002L490.669 515.243L536.24 536.762Z" 
      fill={getFillByLot(24, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("7"))}
      d="M464.087 449.414L479.278 413.971L523.582 435.49L508.392 470.934L464.087 449.414Z" 
      fill={getFillByLot(7, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("8"))}
      d="M448.897 486.124L464.087 449.414L509.657 470.933L494.467 506.377L448.897 486.124Z" 
      fill={getFillByLot(8, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("23"))}
      d="M521.049 574.737L536.239 536.762L490.669 515.242L475.479 553.217L521.049 574.737Z" 
      fill={getFillByLot(23, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("22"))}
      d="M504.594 612.708L521.05 574.732L475.479 553.213L459.023 592.454L504.594 612.708Z" 
      fill={getFillByLot(22, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("9"))}
      d="M433.711 522.838L448.901 486.129L494.471 506.382L479.281 544.358L433.711 522.838Z" 
      fill={getFillByLot(9, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("10"))}
      d="M418.516 559.547L433.706 522.838L479.276 544.357L464.086 579.801L418.516 559.547Z" 
      fill={getFillByLot(10, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("21"))}
      d="M488.138 650.686L504.594 612.711L459.024 592.457L443.834 630.432L488.138 650.686Z" 
      fill={getFillByLot(21, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("11"))}
      d="M404.595 594.987L418.519 559.543L464.089 579.796L448.899 616.506L404.595 594.987Z" 
      fill={getFillByLot(11, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("20"))}
      d="M472.949 688.658L488.139 650.683L443.835 630.43L427.379 668.405L472.949 688.658Z" 
      fill={getFillByLot(20, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("12"))}
      d="M389.404 631.696L404.594 594.986L448.899 616.506L433.709 651.949L389.404 631.696Z" 
      fill={getFillByLot(12, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("13"))}
      d="M372.945 669.675L389.401 631.699L433.705 651.953L418.515 688.662L372.945 669.675Z" 
      fill={getFillByLot(13, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("19"))}
      d="M456.492 727.903L472.947 688.662L427.377 668.408L412.187 707.649L456.492 727.903Z" 
      fill={getFillByLot(19, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("18"))}
      d="M440.036 764.611L456.492 727.902L412.188 707.648L395.732 745.624L440.036 764.611Z" 
      fill={getFillByLot(18, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("14"))}
      d="M359.023 705.115L372.948 669.672L418.518 689.925L404.594 724.103L359.023 705.115Z" 
      fill={getFillByLot(14, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("15"))}
      d="M342.564 741.825L359.02 705.115L404.59 725.369L388.134 762.078L342.564 741.825Z" 
      fill={getFillByLot(15, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("16"))}
      d="M331.172 772.204L342.564 741.824L388.137 762.078L378.01 789.926L338.767 786.129C328.64 784.103 329.484 776.002 331.172 772.204Z" 
      fill={getFillByLot(16, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("17"))}
      d="M419.781 796.255L378.008 789.926L395.73 745.621L440.034 764.609L431.173 788.66C428.135 794.736 422.312 796.255 419.781 796.255Z" 
      fill={getFillByLot(17, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
      <pattern 
      id="pattern0_1465_19732" 
      patternContentUnits="objectBoundingBox" 
      width="1" 
      height="1">
      <use href="#image0_1465_19732" transform="matrix(0.00168927 0 0 0.00230189 -2.42314 -1.9123)"/>
      </pattern>
      <image
        id="image0_1465_19732"
        width="4096"
        height="2304"
        href="/mz2.png"
      />
    </defs>
</svg>

  );
};
